import { useContext, useEffect, useRef } from 'react';
import { ModalRegistrationContext } from './ModalContext';
/**
 * A custom hook for a remote component to register and unregister its modals
 * with the central ModalOrchestrator.
 *
 * @param {string} namespace - A unique string to namespace the modal keys (e.g., 'order').
 * @param {ModalMapInput} modals - The dictionary of modals to register.
 */
export const useRegisterModals = (namespace, modals) => {
    const registration = useContext(ModalRegistrationContext);
    const modalKeysSignature = Object.keys(modals).sort().join('|');
    const registerModalsRef = useRef(registration === null || registration === void 0 ? void 0 : registration.registerModals);
    const unregisterModalsRef = useRef(registration === null || registration === void 0 ? void 0 : registration.unregisterModals);
    const modalsRef = useRef(modals);
    registerModalsRef.current = registration === null || registration === void 0 ? void 0 : registration.registerModals;
    unregisterModalsRef.current = registration === null || registration === void 0 ? void 0 : registration.unregisterModals;
    modalsRef.current = modals;
    useEffect(() => {
        if (!registerModalsRef.current || !unregisterModalsRef.current) {
            return;
        }
        registerModalsRef.current(namespace, modalsRef.current);
        return () => {
            var _a;
            (_a = unregisterModalsRef.current) === null || _a === void 0 ? void 0 : _a.call(unregisterModalsRef, namespace);
        };
    }, [namespace, modalKeysSignature]);
};
